




























import { Component, Vue } from "vue-property-decorator";
import InfoPesertaSvc from "@/services/bridgingVclaim/Peserta";
import { storeRefFaskes } from "@/store/modules/bridgingVclaim/RefFaskes";
import { storeRefPoli } from "@/store/modules/bridgingVclaim/RefPoli";
import { storeRefDokter } from "@/store/modules/bridgingVclaim/RefDokter";
import { storeRefDiagnosa } from "@/store/modules/bridgingVclaim/RefDiagnosa";
import moment from "moment";
import { storeSEP } from "@/store/modules/bridgingVclaim/SEP";
import storePeserta from "@/store/modules/bridgingVclaim/Peserta";

@Component({
  components: {}
})
export default class BpjsVclaimSearchBar extends Vue {
  today = new Date().toISOString().substr(0, 10);
  tab = "tab-info";
  tabs = [
    { name: "Info Peserta", target: "tab-info" },
    { name: "SEP", target: "tab-sep" },
    { name: "Data SEP", target: "tab-data-sep" },
    { name: "Referensi", target: "tab-ref" }
  ];
  searchKey = "";
  responseVclaim = null;
  messageVclaim = "Peserta Tidak Ditemukan!";
  loadingPeserta = false;
  type = { value: "noka", text: "No.Kartu" };
  searchType = [
    { value: "noka", text: "No.Kartu" },
    { value: "nik", text: "NIK" }
  ];
  showWarningDialog = false;
  warningDialogText = "";

  created() {
    storeRefFaskes.act_ref_faskes("");
    storeRefPoli.getListPoli();
    storeRefDokter.act_ref_dokter("");
    storeRefDiagnosa.act_ref_diagnosa("");
  }

  get info() {
    const resp = this.responseVclaim;
    // const resp = null;

    return resp
      ? {
          nama: resp.nama,
          nik: resp.nik,
          noka: resp.noKartu,
          noMr: resp.mr.noMR,
          telp: resp.mr.noTelepon,
          pisa: resp.pisa,
          sex: resp.sex,
          status: resp.statusPeserta.keterangan,
          faskesPrimer: {
            id: resp.provUmum.kdProvider,
            name: resp.provUmum.nmProvider
          },
          tglLahir: resp.tglLahir,
          jenisPeserta: {
            id: resp.jenisPeserta.kode,
            name: resp.jenisPeserta.keterangan
          },
          informasi: {
            dinsos: resp.informasi.dinsos,
            noSKTM: resp.informasi.noSKTM,
            prolanisPRB: resp.informasi.prolanisPRB
          },
          hakKelas: {
            id: resp.hakKelas.kode,
            name: resp.hakKelas.keterangan
          },
          cob: {
            nama: resp.cob.nmAsuransi,
            nomor: resp.cob.noAsuransi,
            tglTAT: resp.cob.tglTAT,
            tglTMT: resp.cob.tglTMT
          }
        }
      : null;
  }

  get todayDate() {
    return moment().format("YYYY-MM-DD");
  }

  get lastNoSEP() {
    return storeSEP.lastNoSEP;
  }

  async getPeserta() {
    if (!this.loadingPeserta) {
      this.loadingPeserta = true;

      let service = null;

      if (this.type && this.type.value === "noka") {
        service = InfoPesertaSvc.getByNoka(this.searchKey, this.todayDate);
      } else if (this.type && this.type.value === "nik") {
        service = storePeserta.getByNik(this.searchKey, this.todayDate);
      } else {
        return false;
      }

      const resp = await service;

      if (resp.status == 1) {
        this.responseVclaim = resp.data?.peserta;
      } else {
        this.responseVclaim = resp.data;

        if (resp.message) {
          this.messageVclaim = resp.message;
          this.warningDialogText = `No Kartu ${this.searchKey}: ${resp.message}`;
          this.showWarningDialog = true;
        }
      }

      console.log("store get peserta by noka", resp.data);
      storePeserta.SET_PESERTA(resp.data ? resp.data.peserta : null);
    }

    this.loadingPeserta = false;
  }
}
